/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */

import { inject, ChangeDetectorRef, Directive, ElementRef } from '@angular/core';
import { Sihwlog } from "sihw-ngx";

/**
 * Abstracte basisklasse voor de componenten die tot golf 4f als eiland in de AngularJS-pagina stonden:
 * een logger op naam van de subklasse, de `ChangeDetectorRef`, het host-element en `doeUpdate`.
 *
 * Tot golf 4f hing de constructor hier de met `@hostapi()` gemarkeerde methoden aan het host-element,
 * zodat AngularJS ze kon aanroepen. Die decorator is met AngularJS weggegaan; de naam van de klasse is
 * blijven staan, hernoemen is opruimwerk.
 *
 * Gegenereerd met Junie (AI), 04-03-2026
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 */
@Directive()
export abstract class BaseIslandComponent {
  /**
   * De ChangeDetectorRef, voor `markForCheck` in de subklassen en voor `doeUpdate`.
   */
  protected readonly cdr = inject(ChangeDetectorRef);

  /**
   * Host element referentie.
   */
  protected readonly elementRef = inject(ElementRef);

  protected log: Sihwlog;

  constructor(loglevel?: string) {
    //init logging
    this.log = new Sihwlog(loglevel, this.constructor.name);
  }

  /**
   * Draait meteen een change detection op dit component.
   */
  public doeUpdate(): void {
    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
}
